import { SidebarTrigger } from '@/components/ui/sidebar';

export function AppBar() {
  return (
    <header className='bg-primary flex h-14 shrink-0 items-center gap-2 px-4'>
      <SidebarTrigger className='text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground -ml-1' />
      <div id='appbar-portal' className='ml-auto flex items-center' />
    </header>
  );
}
